import { useCombinedQueriesTeamGeneralInfo } from '@/hooks/query/useCombinedQueriesTeamGeneralInfo';
import { useQueryUser } from '@/hooks/query/useQueryUser';
import { useEvidenceAccess } from '@/hooks/useEvidenceAccess';

/**
 * Shared gate for the sessionless Evidence chat surface (`/scribe/chat`).
 * Work home is a subset: callers that route to Work should treat
 * ``isBlocked`` the same way this page treats its blocking UI.
 */
export function useEvidenceChatSurfaceGate() {
  const { data: userData, isPending: isPendingUser } = useQueryUser((data) => ({
    hasSeenEvidenceDisclaimer: data?.evidence_settings?.has_seen_evidence_disclaimer,
  }));
  const {
    isSessionlessEvidenceShown,
    isNhsUser,
    isPending: isPendingAccess,
    showManagedTeamActivationRequest,
  } = useEvidenceAccess();
  const { hasTeam, isLoadingTeamDetails, isJoinedTeamsFetched } =
    useCombinedQueriesTeamGeneralInfo();

  const showNhsContactSales = isNhsUser && !isSessionlessEvidenceShown;
  const showNhsDisclaimer =
    isNhsUser && isSessionlessEvidenceShown && !userData?.hasSeenEvidenceDisclaimer;

  const isLoading =
    isPendingAccess ||
    isPendingUser ||
    !isJoinedTeamsFetched ||
    (hasTeam && isLoadingTeamDetails);

  const isBlocked =
    showNhsContactSales ||
    showNhsDisclaimer ||
    showManagedTeamActivationRequest ||
    !isSessionlessEvidenceShown;

  return {
    isLoading,
    isBlocked,
    showNhsContactSales,
    showNhsDisclaimer,
    showManagedTeamActivationRequest,
    isSessionlessEvidenceShown,
    isNhsUser,
  };
}
